import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';

/**
 * Header reutilizable de cada pantalla del flujo de captura.
 * Formato: "Paso N de 5 – <stepName>" en texto legible (sin uppercase ni letter-spacing exagerado).
 *
 * Props:
 *   - step      : número del paso actual (1..total)
 *   - total     : total de pasos (5 por defecto)
 *   - stepName  : nombre legible del paso (ej. "Conducta observable")
 *   - title     : título principal de la pantalla (ej. el nombre del dominio)
 *   - subtitle  : descripción breve
 *   - eta       : tiempo estimado restante
 *   - onBack    : handler back
 *   - tone      : { color } opcional para acentar el step con el color del dominio
 */
const ScreenHeader = ({ onBack, step, total = 5, stepName, title, subtitle, eta, tone }) => {
  const accent = tone?.color || '#5346E6';
  return (
    <div className="px-5 pt-3 pb-4" data-testid={`screen-header-step-${step}`}>
      <div className="flex items-center justify-between">
        <button
          onClick={onBack}
          data-testid="screen-back"
          aria-label="Atrás"
          className="tap-44 w-11 h-11 rounded-full bg-white border border-[#DDE6F7] flex items-center justify-center text-brand-deep hover:text-brand-violet hover:border-brand-violet transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        {eta && (
          <div className="flex items-center gap-1.5 text-brand-muted">
            <Clock className="w-3.5 h-3.5" />
            <span className="text-xs font-semibold">{eta}</span>
          </div>
        )}
      </div>

      <div className="mt-4">
        <p
          data-testid={`screen-step-label-${step}`}
          className="text-[13px] font-bold"
          style={{ color: accent }}
        >
          Paso {step} de {total} – {stepName}
        </p>
        {title && (
          <h2
            className="mt-1.5 text-2xl font-extrabold text-brand-deep leading-tight"
            style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
          >
            {title}
          </h2>
        )}
        {subtitle && <p className="mt-1.5 text-sm text-brand-muted leading-relaxed">{subtitle}</p>}
      </div>

      <div className="progress-dots mt-4">
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} className={i + 1 < step ? 'is-done' : i + 1 === step ? 'is-active' : ''} />
        ))}
      </div>
    </div>
  );
};

export default ScreenHeader;
